export default __webpack_public_path__ + "static/media/services.957378e2.png";